import { Header } from "./Header.";
import Footer from "./Footer";

import "./Styles/login.css";
import React, { useEffect, useState } from "react";
import LoginLoader from "../Images/login-filter.gif";

import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { v4 as uuidv4 } from 'uuid';

export const PasswordForget = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  document.title = "Mot de passe oublié - KabaaShop";

  const sendPasswordRequest = () => {
    setLoading(true)
    axios.get(process.env.REACT_APP_API_BASE_URL + '/api/users?email=' + email,
      {
        headers: {
          'x-api-token': process.env.REACT_APP_API_TOKEN,
        }
      }).then(a => {
        if (a.data.length == 0) {
          setLoading(false)
          toast.error("Aucun utilisateur n'a été trouvé pour cette adresse !")
        }
        else {
          let token = uuidv4();

          axios.post(process.env.REACT_APP_API_BASE_URL + '/api/password_reset_requests',
            {
              user: 'api/users/' + a.data[0].id,
              token: token
            },
            {
              headers: {
                'x-api-token': process.env.REACT_APP_API_TOKEN,
              }
            }).then(a => {
              axios.post(process.env.REACT_APP_API_BASE_URL + '/services/email/sendToEmail?type=PasswordRecovery&email='+email+'&token=' + token, {},
                {
                  headers: {
                    'x-api-token': process.env.REACT_APP_API_TOKEN,
                  }
                }).then(a => {
                  setLoading(false)

                  toast.success('Un mail de récupération à été envoyé à l\'adresse ' + email)
                }).catch(error => {
                  toast.error('Une erreur est survenue');
                })
            }).catch(error => {
              toast.error('Une erreur est survenue');
              setLoading(false)
            })

        }
      }).catch(error => {
        toast.error('Une erreur est survenue');
        setLoading(false)
      })
  }

  return (
    <>
      <ToastContainer />
      <Header />
      <div className="login-main">
        <div className="login">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              sendPasswordRequest();
            }}
          >
            <p className="login-label">Mot de passe oublié</p>
            <input
              disabled={loading}
              className="login-input"
              type="email"
              placeholder="Adresse Email"
              required
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <button disabled={loading} className="login-button">
                <span
                  style={{ display: loading ? "none" : "block" }}
                  className="login-btn-text"
                >
                  Valider
                </span>
                <span
                  style={{ display: loading ? "block" : "none" }}
                  className="login-btn-img"
                >
                  <img src={LoginLoader}  alt="loading"/>
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};
